(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    const amount = (Number(cents || 0) / 100).toLocaleString('en-IN', {
      maximumFractionDigits: 0
    });

    return 'Rs. ' + amount;
  }

  function initStickyAtc(sticky) {
    const form = sticky.querySelector('[data-pikuchi-sticky-form]');
    const idInput = sticky.querySelector('[data-pikuchi-sticky-id]');
    const button = sticky.querySelector('[data-pikuchi-sticky-button]');
    const priceEl = sticky.querySelector('[data-pikuchi-sticky-price]');
    const compareEl = sticky.querySelector('[data-pikuchi-sticky-compare]');
    const qtyInput = sticky.querySelector('[data-pikuchi-qty]');
    const minus = sticky.querySelector('[data-pikuchi-qty-minus]');
    const plus = sticky.querySelector('[data-pikuchi-qty-plus]');
    const productJsonEl = sticky.querySelector('[data-pikuchi-sticky-product-json]');

    let productData = null;

    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (error) {
      productData = null;
    }

    function getMainVariantInput() {
      const inputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
      return inputs.find(function (input) {
        return input !== idInput && !input.closest('[data-pikuchi-sticky-atc]');
      });
    }

    function getVariantById(id) {
      if (!productData || !Array.isArray(productData.variants)) return null;
      return productData.variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function syncFromMainForm() {
      const mainInput = getMainVariantInput();
      const newId = mainInput ? mainInput.value : idInput.value;

      if (newId && String(idInput.value) !== String(newId)) {
        idInput.value = newId;
      }

      const variant = getVariantById(newId);

      if (variant) {
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(variant.compare_at_price);
          } else {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
        }

        if (button) {
          if (variant.available) {
            button.disabled = false;
            button.textContent = button.dataset.defaultText || button.textContent || 'ADD TO CART';
          } else {
            button.disabled = true;
            button.textContent = 'SOLD OUT';
          }
        }
      }
    }

    if (button) {
      button.dataset.defaultText = button.textContent.trim();
    }

    document.addEventListener('change', function () {
      setTimeout(syncFromMainForm, 80);
    });

    document.addEventListener('variant:change', function () {
      setTimeout(syncFromMainForm, 80);
    });

    document.addEventListener('shopify:section:load', function () {
      setTimeout(syncFromMainForm, 120);
    });

    if (minus && qtyInput) {
      minus.addEventListener('click', function () {
        const current = Math.max(1, Number(qtyInput.value || 1));
        qtyInput.value = Math.max(1, current - 1);
      });
    }

    if (plus && qtyInput) {
      plus.addEventListener('click', function () {
        const current = Math.max(1, Number(qtyInput.value || 1));
        qtyInput.value = current + 1;
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        syncFromMainForm();
      });
    }

    syncFromMainForm();
    setTimeout(syncFromMainForm, 500);
  }

  function init() {
    document.querySelectorAll('[data-pikuchi-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();